import React from 'react';
import { usePageTitle } from '@/__core/layout';
import { useSelector } from 'react-redux';
import LoadingBackdrop from '@/__core/helpers/components/LoadingBackdrop';
import ReportFinancial from '@/modules/finance/report_financial';

export default function ReportFinancialPage() {
    usePageTitle('Thu Chi');
    const { loading } = useSelector((state: any) => state.transactions);

    return (
        <>
            <ReportFinancial />
            <LoadingBackdrop 
                open={loading} 
                message="Đang tải dữ liệu..." 
            />
        </>
    );
}

